import Theme from "/components/Theme";
import Hero from "/components/organisms/integrations/Hero";
import People from "/components/organisms/common/People";
import WideCTA from "/components/organisms/common/WideCTA";
import BoxShadowCard from "/components/organisms/common/BoxShadowCard";
import CTA from "/components/organisms/common/CTA";
import FAQ from "/components/organisms/common/FAQ";
import HighlightFeaturesCards from "/components/organisms/common/HighlightFeaturesCards";
import LogoAsideWithContent from "/components/organisms/integrations/LogoAsideWithContent";
import Schema from "../../../components/organisms/common/Schema";
import AppStorage from "../../../components/AppStorage";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export async function getStaticPaths({ locales }) {
  // Fetch All Path
  const res = await fetch(`${process.env.JSON_PATH}/routes.json`);
  const data = await res.json();

  // Specific Paths
  let routes = data.integrations.square;

  // Variable for returning path
  let paths = [];

  // Create Paths with locales
  routes.forEach((path) => {
    for (const locale of locales) {
      paths.push({
        params: {
          page: path,
        },
        locale,
      });
    }
  });
  // return to getStaticProps()
  return {
    paths,
    fallback: false,
  };
}
export async function getStaticProps({ params, locale }) {
  let allData = {};

  // Fetch
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );
  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );
  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/integrations/square/${params.page}/marketing.json`
  );
  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/integrations/square/${params.page}/content.json`
  );

  // Catch Error
  if (marketingResponse.status === 404 || contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...allData.marketing,
    ...allData.content,
  };

  return {
    props: {
      data,
      pageName: params.page,
      lang: locale,
    },
  };
}

export default function Industry({ data, pageName, lang }) {
  const { header, footer, seo, content } = data;
  return (
    <>
      <Theme
        header={header}
        footer={footer}
        className={`integration-listing-page ${content.helpers.pagename}`}
        seo={seo}
      >
        <AppStorage pageName={`Integrations Sub Page - square/${pageName}`} />
        <Hero data={content.hero} />
        <section className="bg-offset bg-offset-top bg-light md:pt-2 md:pb-10">
          <BoxShadowCard data={content.integrationFeatures} hasOffset={true} />
        </section>
        <LogoAsideWithContent data={content.howToIntegrate} />
        <CTA
          data={content.cta}
          imgClassName={`img-fit`}
          className="bg-light lg:pt-20 md:pt-10"
        />
        {content.hasOwnProperty("highlightFeaturesCards") && (
          <HighlightFeaturesCards data={content.highlightFeaturesCards} />
        )}
        {content.hasOwnProperty("faqs") && (
          <>
            <FAQ
              data={content.faqs}
              className="lg:mb-15 md:mb-10 faq-section bg-offset-top"
            />
            <Schema data={content.faqs.list} />
          </>
        )}
        <People className="" />
        <WideCTA data={content.wideCTA} />
        <style jsx global>{`
          :global(.hero--default) img {
            object-fit: cover;
          }
          @media (max-width: ${viewport.tablet.sm}) {
            :global(.hero--default) img {
              height: auto !important;
            }
          }
        `}</style>
      </Theme>
    </>
  );
}
